module.exports = __webpack_public_path__ + "267dcca68a09eb2f743d5ea9492e83fd.gif";